import { Link } from "react-router-dom";
import { latestUpdates } from "@/mocks/anime";

export default function LatestUpdates() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">最新更新</h2>
          <p className="text-sm text-foreground-600 mt-2">每日更新，追番不等待</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {latestUpdates.map((anime) => (
          <Link
            key={anime.id}
            to={`/article/${anime.id}`}
            className="group flex gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer"
          >
            <div className="relative w-[100px] h-[140px] flex-shrink-0 overflow-hidden rounded-lg">
              <img
                src={anime.coverImage}
                alt={anime.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                title={`${anime.title} - 51动漫下载`}
              />
              {anime.isNew && (
                <div className="absolute top-1.5 left-1.5 bg-accent-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-md">
                  NEW
                </div>
              )}
            </div>
            <div className="flex-1 min-w-0 flex flex-col justify-between py-1">
              <div>
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {anime.title}
                </h3>
                <div className="flex items-center gap-1.5 mt-1.5">
                  <span className="text-xs px-1.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 font-medium">
                    {anime.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-star-fill text-yellow-500 text-xs"></i>
                  <span>{anime.rating}</span>
                  <span className="mx-1 text-foreground-300">·</span>
                  <span>{anime.episodeCount}</span>
                </div>
                <span className="text-xs text-foreground-400">{anime.views} 次播放</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}